import { render, staticRenderFns } from "./VminstanceList.vue?vue&type=template&id=8b8b5bc8&"
import script from "./VminstanceList.vue?vue&type=script&lang=js&"
export * from "./VminstanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports